import { FC, ReactNode } from "react";
import { auth } from "../../auth/client";

interface WithPublicFallbackProps {
  authenticatedComponent: ReactNode;
  unauthenticatedComponent: ReactNode;
}

const WithPublicFallback: FC<WithPublicFallbackProps> = function ({
  authenticatedComponent,
  unauthenticatedComponent,
}) {
  // Check if user has a token (synchronous check)
  const token = auth.getTokenOrUndefined();

  // Check for refresh token in localStorage
  // The key format is usually "@osdk/oauth : refresh : <client_id>"
  const hasRefreshToken = Object.keys(localStorage).some((key) =>
    key.startsWith("@osdk/oauth : refresh"),
  );

  // If we have either token, render the authenticated component (which contains WithActiveSubscription)
  if (token || hasRefreshToken) {
    return authenticatedComponent;
  }

  // Otherwise, render the unauthenticated (public) component
  return unauthenticatedComponent;
};

export default WithPublicFallback;
